module.exports = __webpack_public_path__ + "static/media/nike-the-ball-makes-us-more.948ba18b.jpg";